import { render, staticRenderFns } from "./PageInformationComponent.vue?vue&type=template&id=4bcd9a04&scoped=true&"
import script from "./PageInformationComponent.vue?vue&type=script&lang=js&"
export * from "./PageInformationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageInformationComponent.vue?vue&type=style&index=0&id=4bcd9a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd9a04",
  null
  
)

export default component.exports